import React from 'react';
import { SelectableColors } from '@/types/content';
interface HeadingNoIndexProps {
  level: '1' | '2' | '3' | '4' | '5' | '6';
  title?: string;
  color?: SelectableColors;
  bold?: boolean;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const HeadingNoIndex = ({ 
  level,
  title,
  color,
  bold,
  attributes  
}: HeadingNoIndexProps) => {
  const colorClass = 
    color === "brand" ? "text-brand" : 
    color === "primary" ? "text-foreground" : 
    color === "secondary" ? "text-muted-foreground" : 
    "text-foreground";
  const boldClass = bold ? "font-bold" : "font-normal";
  const { key, ...rest } = attributes ?? {};
  const headingClass = `heading-${level}`;
  const headingId = `heading-${key}`;

  return (
    <div
      key={key}
      {...rest}
      className="content-heading"
    >
      <div 
        id={headingId} 
        className={`${colorClass} ${boldClass} ${headingClass}`}
      >
        {title ?? ''}
      </div>
    </div>
  );
}; 